// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter-active[data-v-6734f10f],.fade-leave-active[data-v-6734f10f]{transition:opacity .5s}.fade-enter[data-v-6734f10f],.fade-leave-to[data-v-6734f10f]{opacity:0}.topCard[data-v-6734f10f]{background-color:#f1f1f1;border-radius:1em;margin:4em auto 1em;min-width:250px;padding:3em 1em 1em;position:relative}.imageTop[data-v-6734f10f]{left:50%;margin-left:-36px;position:absolute;top:-30px;width:72px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
